import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import {FETCH_DETAIL_CUSTOMER} from '../../Customer/constants';

export default function*() {
    yield takeLatest(FETCH_DETAIL_CUSTOMER.SUCCESS, saga.onFetchDetailCustomerSuccess);
}
